import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Colors, Web_url } from "../../../common/Const";
import { images } from "../../../common/Images";
import String from "../../../lang/String";
import store from "../../../redux/Store";
import SkeletonEffect from "./SkeletonEffect";

function Categories(props) {
  const { categoryData } = props;
  // console.log("category -->", categoryData);
  const navigate = useNavigate();
  const arr = [
    {
      title: "Rings",
      price: "9,000",
    },
    {
      title: "Earrings",
      price: "10,000",
    },
    {
      title: "Waist Chain",
      price: "15,000",
    },
    {
      title: "Pendants",
      price: "25,000",
    },
    {
      title: "Necklace",
      price: "35,000",
    },
    {
      title: "Bangles",
      price: "14,000",
    },
  ];

  const catFilter = (catId) => {
    console.log("calling filter -->>",catId)
    store.dispatch({ type: "setCatparams", payload: catId });
    navigate('/filter');
  }
  return (
    <div className="container mt-4">
      <p className="h3 text-center my-4" style={{ color: Colors.Base_color }}>
        {String.home_headings.Shop_by_categories}
      </p>
      <div className="row">
        {categoryData && categoryData != null ? (
          <>
            {categoryData.slice(0,6).map((data) => {
              return (
                <Fragment key={data.id}>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 d-flex p-2" role={"button"} onClick={() => catFilter(data.id)}>
                  <div className="d-flex w-100">
                    <div className="col-6">
                      <img
                        src={Web_url.Domain_url+data.image}
                        style={{
                          width: "-webkit-fill-available",
                          height: "160px",
                          objectFit: "cover",
                        }}
                        className="rounded-start"
                      />
                    </div>
                    <div
                      className="col-6 rounded-end d-flex flex-column justify-content-center px-3"
                      style={{
                        backgroundColor: Colors.Base_color,
                        color: Colors.white_color,
                      }}
                    >
                      <p className="h6 mb-2 fs-5">{data.category_name}</p>
                      <span className="mt-2 coll-md-text">Start From</span>
                      <span className="coll-md-text">₹ {data.start_price.toLocaleString("en-US")}</span>
                      <i class="fa-sharp fa-solid fa-circle-arrow-right text-end mt-2"></i>
                    </div>
                  </div>
                </div>
                </Fragment>
              );
            })}
          </>
        ) : (
          <>
            {arr.map((data) => {
              return (
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 d-flex p-2">
                  <div className="d-flex w-100">
                    {/* <div className="col-6"> */}
                      {/* <img
                        src={images.model1}
                        style={{
                          width: "-webkit-fill-available",
                          height: "160px",
                          objectFit: "cover",
                        }}
                        className="rounded-start"
                      /> */}
                      <SkeletonEffect  className={"rounded-start rounded-end"} height={"160px"} />

                    {/* </div> */}
                    {/* <div
                      className="col-6 rounded-end d-flex flex-column justify-content-center px-3"
                      style={{
                        backgroundColor: Colors.Base_color,
                        color: Colors.white_color,
                      }}
                    > */}
                      {/* <SkeletonEffect  className={"rounded-end"} height={"160px"} /> */}
                      {/* <p className="h6 mb-2 fs-5">{data.title}</p>
                      <span className="mt-2 coll-md-text">Start From</span>
                      <span className="coll-md-text">₹ {data.price}</span>
                      <i class="fa-sharp fa-solid fa-circle-arrow-right text-end mt-2"></i> */}
                    {/* </div> */}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

export default Categories;
